import { render, staticRenderFns } from "./OrderDetailsPage.vue?vue&type=template&id=2fcb90ad&scoped=true"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb90ad",
  null
  
)

export default component.exports